import { Navigate } from "react-router-dom"

export default function NewCallRedirect() {
  return <Navigate to="/new-call" replace />
}

export function CallLibraryRedirect() {
  return <Navigate to="/call-library" replace />
}
